<app-report helpTemplate="chart-report"
            [actionsConfig]="['filters']"
            [paramsConfig]="['chartDimensions', 'chartMetrics', 'new_period_without_comparison']"
            [iframe]="iframe$ | async"
            [disableDownloads]="true"
            [enableDialogs]="true">
  <ng-container actions>
    <app-chart-settings [params]="requestParams$ | async"
                        [disabled]="!(initialized$ | async)"></app-chart-settings>
  </ng-container>
  <app-chart></app-chart>
</app-report>
